$(document).ready(function(){
  if (document.URL.indexOf("/products") >= 0) {
    $(document).ready(function () {
      var ProductMetaTitleNoColor = document.querySelector('.product-meta__title').innerHTML.split(' - ')[0].replace(/\s/g, '').replace("'", '').replace("-", '').replace('&','-').replace(".", '').replace("(", '').replace(")", '');
      var vendor = document.querySelector('.product-meta__vendor').getAttribute("href").split("/").pop().replaceAll('&','-').replaceAll('-', ' ').replaceAll(/(^\w|\s\w)/g, m => m.toUpperCase()).replaceAll(" ", "");
      var vendor2 = document.querySelector('.product-meta__vendor').getAttribute("href").split("/").pop();
      var ProductMetaTitleTag = "ProductGroup:" + ProductMetaTitleNoColor;

      var ProductTypeColor = document.querySelector('.product-meta__title').innerHTML.split(' - ')[1].replace(' ','-').replace('&','-').replace('&','-').toLowerCase();

      var replace = vendor2.replaceAll('&','-').replaceAll('-','');
      var re = new RegExp(replace,"gi");
      ProductMetaTitleTag = ProductMetaTitleTag.replace(re,'');
      console.log('Vendor',replace);

      console.log('PMTN',ProductMetaTitleNoColor);
      console.log('PMTT',ProductMetaTitleTag);

      var settings_first = {
        "url": "https://workwearhub.com.au/api/2023-04/graphql.json",
        "method": "POST",
        "timeout": 0,
        "headers": {
          "X-Shopify-Storefront-Access-Token": "1d89833ec6d4ba3014407b58644b4716",
          "Authorization": "Basic ODBmOTg5YWRiMDMyMTY1ZWVkYWIwN2Y2ZTNmMjhiZmI6MDVkYzJjMTQwOWJiZmU0ZTk0MDc2YzM4YmJlYTFhODc=",
          "Content-Type": "application/json",
          "Cookie": "__cfduid=dacbe258d4f5d099787913543522794be1597718597; request_method=POST"
        },
        "data": JSON.stringify({
          query: "{shop{primaryDomain{url}}products(first: 15, query:\"tag:'" + ProductMetaTitleTag + "'\" ) {edges {node { id title tags onlineStoreUrl handle images(first:1){edges{node{originalSrc}}}}}}}",
          //query: "{products(first:250){edges {node { title }}}}",
          variables: {}
        })
      };

      $.ajax(settings_first).done(function (response) {
        var shopUrl = response.data.shop.primaryDomain.url;
        var arrayResponse = response.data.products.edges;

        let items = arrayResponse.map(element => (element));
        let arrayImgs = items.map(element => element.node.images.edges);
        let arrayTitles = items.map(element => element.node.title.toLowerCase().split(' - ')[1].split('/'));
        let arrayHandles = items.map(element => shopUrl + "/products/" + element.node.handle);
        let arrayImgsSrc = arrayImgs.map(element => element[0].node.originalSrc);

        let arrayItem = arrayImgsSrc.map((imageSrc, i) => ({
          imageSrc,
          productURL: arrayHandles[i],
          color: arrayTitles[i]
        }));

        let myItemList = document.getElementById('myItemList');
        let div_title = document.createElement('div');
        let ul = document.createElement('ul')
        div_title.className = Array.isArray(arrayItem) && arrayItem.length ? "myList-title product-form__info-title text--strong" : "product-form__info-title text--strong myList-title -hidden";
        div_title.innerHTML = arrayItem.length === 1 ? 'Colour:' : 'Colours:';
        myItemList.appendChild(div_title);
        myItemList.appendChild(ul);

        arrayItem.forEach(function (item) {

          let li = document.createElement('li');
          let a = document.createElement('a');
          let span = document.createElement('span');

          ul.appendChild(li);
          li.appendChild(a);
          a.appendChild(span);
          let isCurrentProduct = ProductTypeColor === item.color.toString().replace(',', '/').replace(' ', '-');

        
          if (!isCurrentProduct){
            if (window.location.href.indexOf("work-wear-hub-staging.myshopify.com") > -1) {
              var string = item.productURL;
              var new_string = string.replace('https://www.workwearhub.com.au/','https://work-wear-hub-staging.myshopify.com/');
			  a.href += new_string;
            }else{
              a.href += item.productURL;
            }
          }
          if (isCurrentProduct) li.className = "-current-produt-list";
          let arrayColors = [];
          
      
          
          if (item.color.length > 1) {
            item.color.forEach((item) => {
              item = item.replace(/\s/g, '-');
              let span = document.createElement('span');
              span.className = `other-products-span-color ${'color-' + item} -hide-span`;
              a.appendChild(span);
              var primaryColorClass = ".color-" + item;
              var element = document.querySelector(primaryColorClass);
              style = window.getComputedStyle(element);
              var background_color = style.getPropertyValue('background-color');
              arrayColors.push(background_color);
              //                           element.style.visibility = "hidden";
              //                           element.style.height = "0";
              element.style.border = "none";
              
            
              
            });

            
        
            
            let stringLinearGradient = "";
            arrayColors.forEach((color, i) => {
              const partOfTotal = 100 / (arrayColors.length + 1);
              stringLinearGradient += `${color} ${i * partOfTotal + partOfTotal}%${i===arrayColors.length - 1 ? '' : ', '}`
            })
            span.className = 'other-products-span-color';
            span.style = `background: linear-gradient(135deg, ${stringLinearGradient});`;


            span.title = `.${'color-' + item.color.toString()}`;
          } else {
            console.log('Hppay');
            span.className = `other-products-span-color  ${'color-' + item.color[0].replace(/\s/g, '-')}`;
            span.title = `.${'color-' + item.color[0].replace(/\s/g, '-')}`;
          }
        });
      });
    });
  }
});